import React, { useEffect,useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ProtectedRoutes from "./routes/protected-routes";
import PublicRoutes from "./routes/public-route";
import { protectedRoutes, publicRoutes } from "./routes/routes";
import NotFound from "./components/not-found";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.scss";
import "antd/dist/antd.min.css";
import userServiceApi from "./api/userServiceApi";
import { getRequest } from "./api/http";
import { setGeneratingAI, setMicroSites } from "./store/actions";
import { useStore } from "./store";
import "react-phone-number-input/style.css";
import { subscribeToAiStatus, unsubscribeFromAiStatus } from "./services/websocketService";
import MissingTabsModal from "./components/app-features/MissingTabsModal";

function App() {
  const token = localStorage.getItem("token")
  const [missingTabsModal, setMissingTabsModal] = useState(false);
  const [aiWebsocketData, setAiWebsocketData] = useState(null);
  
  const { dispatch, generatingAI } = useStore()
  const getMicrosites = async () => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await getRequest(userServiceApi.getAllMicrosites(), {
      headers,
    });
    if (response && response.data) {
      dispatch(setMicroSites(response?.data))
    }

  }

  const updateAIStatus = (status) => {
    const aiDetails = JSON.parse(sessionStorage.getItem("aiDetails") || "{}");

    const aiData = {
      micrositeID: aiDetails?.micrositeID,
      aiStatus: status,
      isBtnDisabled: false,
      isGeneratingData: false,
    };

    sessionStorage.setItem("aiDetails", JSON.stringify(aiData));

    window.dispatchEvent(
      new CustomEvent("ai-status-updated", {
        detail: aiData,
      })
    );
  };


  useEffect(() => {
    if (!token) return;  // no token → do not call
    getMicrosites(); 
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [token]);


  const subscribeJob = (jobId) => {
    subscribeToAiStatus(jobId, (data) => {
      console.log("Socket Data ===>", data);

      const status = data?.status?.toLowerCase();

      if (status === "completed") {
        console.log('---COMPLETED-----');
        toast.success(data?.message || "AI Data Generation Completed!");
        // 1) Mark AI done in session  2) Hide Rosie  3) Open Site Tabs
        sessionStorage.setItem("rosieProgressDismissed", "true");
        localStorage.setItem("rosieAiComplete", "true");
        updateAIStatus("completed");
        window.dispatchEvent(new CustomEvent("missing-tabs-modal-open"));
        dispatch(
          setGeneratingAI({
            ...generatingAI,
            jobId: null,
            hideRosiePopup: true,
            reRenderMicroSite: !generatingAI.reRenderMicroSite,
          })
        );
        setAiWebsocketData(data);
        setMissingTabsModal(true);

        unsubscribeFromAiStatus(jobId);
      }

      if (status === "failed") {
        toast.error(data?.message || "Something went wrong");
        localStorage.setItem("rosieAiComplete", "true");

        updateAIStatus("failed");

        dispatch(
          setGeneratingAI({
            ...generatingAI,
            jobId: null,
          })
        );

        unsubscribeFromAiStatus(jobId);
      }
    });
  };

  useEffect(() => {
    if (!token) return;
    if (!generatingAI?.jobId) return;
    subscribeJob(generatingAI?.jobId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, generatingAI?.jobId]);

  useEffect(() => {
    if (!token) return;

    if (generatingAI?.jobId) return;

    const aiDetails = JSON.parse(
      sessionStorage.getItem("aiDetails") || "{}"
    );

    if (aiDetails?.jobId) {
      dispatch(
        setGeneratingAI({
          ...generatingAI,
          jobId: aiDetails?.jobId,
        })
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleMissingModalTabsClose = () => {
    sessionStorage.removeItem("aiDetails");
    sessionStorage.removeItem("rosieProgressDismissed");
    localStorage.removeItem("rosieAiComplete");
    setAiWebsocketData(null);
    setMissingTabsModal(false);
    // Keep Rosie closed after Site Tabs cancel (do not reopen progress popup)
    dispatch(
      setGeneratingAI({
        ...generatingAI,
        hideRosiePopup: true,
        jobId: null,
      }),
    );
    window.dispatchEvent(
      new CustomEvent("missing-tabs-modal-close", {
        detail: { allowNewRosiePrompt: false },
      }),
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />

        <Route path="/" element={<ProtectedRoutes />}>
          {protectedRoutes.map((route) => {
            return <><Route path={route.path} element={route.component} /></>
          })}
        </Route>

        {publicRoutes.map((route) => {
          return (
            <Route path={route.path} element={<PublicRoutes />}>
              <Route path={`/${route.path}`} element={route.component} />
            </Route>
          );
        })}
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <MissingTabsModal
        aiWebsocketData = {aiWebsocketData}
        open={missingTabsModal}
        onClose={() => handleMissingModalTabsClose()}
      />
    </Router>
  );
}

export default App;
